import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import classnames from 'classnames'
import { Button, Icon, SpinnerLoader, Typography } from 'shared/ui'
import { makeTextFieldAutoFocus, makeTextFieldError, TextField } from 'shared/ui/TextField'
import { makeTextFieldAutoWidth } from 'shared/ui/TextField/ActionsMain/TextFieldAutoWidth'
import { LINK_SEARCH_SMART_VIEWS } from 'shared/constants/links'
import { FilterEditor, FilterEditorAdd } from 'widgets/FilterEditor'
import { type SmartViewModalStore } from 'widgets/SmartViewModal'
import styles from './styles.module.scss'

type ISmartViewModalContentProps = {
  store: SmartViewModalStore
}

export const SmartViewModalContent: FC<ISmartViewModalContentProps> = observer(({ store }) => {
  const { loading, setTitle, title, errorTitle, filterEditorStore, setError } = store

  if (loading) {
    return (
      <div className={classnames(styles.wrap, styles['wrap--spinner'])}>
        <SpinnerLoader ariaLabel={'ContactCreateModalContent'} />
      </div>
    )
  }

  const renderFilter = () => {
    if (filterEditorStore.groups.count) {
      return <FilterEditor store={filterEditorStore} />
    }

    return (
      <>
        <div className={styles.filterBtn}>
          <FilterEditorAdd
            store={filterEditorStore}
            triggerComponent={() => {
              return (
                <Button icon={'add'} contained={'secondary'} size={'medium'} text={'New filter'} />
              )
            }}
            noSearch
          />
        </div>

        <div className={styles.filterEmpty}>
          <div className={styles.filterEmpty__icon}>
            <Icon icon={'filter'} fontSize={30} />
          </div>
          <Typography
            tag={'div'}
            variant={'heading-md'}
            className={styles.filterEmpty__title}
            ariaLabel={'title'}
          >
            Smart view
          </Typography>
          <Typography
            tag={'div'}
            variant={'body-rg-regular'}
            className={styles.filterEmpty__desc}
            ariaLabel={'desc'}
          >
            Save filters to quickly access matching <br />
            conversations in real time.{' '}
            <a href={LINK_SEARCH_SMART_VIEWS} target={'_blank'} rel='noreferrer'>
              Learn more
            </a>
          </Typography>
        </div>
      </>
    )
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.inputWrap}>
        <TextField
          className={styles.input}
          variant={'outline'}
          InputProps={{
            placeholder: 'Name',
          }}
          onChange={setTitle}
          onBlur={setError}
          value={title}
          size={'small'}
          mainActions={[
            makeTextFieldAutoWidth({ minWidth: 64, maxWidth: 736 }),
            makeTextFieldAutoFocus({ withFocus: true }),
          ]}
          rightActions={[
            makeTextFieldError({
              placement: 'right',
              anchor: 'container',
              offset: [0, 0],
            }),
          ]}
          error={errorTitle}
        />
      </div>
      <div className={styles.filterWrap}>{renderFilter()}</div>
    </div>
  )
})
